import * as yup from 'yup';
import moment from 'moment';
import { maxLengthErrorMessage, requiredErrorMessage } from '../../shared/consts';

const validationSchema = yup.object().shape({
  image_main: yup.mixed().required(requiredErrorMessage),
  name: yup.string().required(requiredErrorMessage).max(100, maxLengthErrorMessage(100)),
  description_short: yup.string().required(requiredErrorMessage).max(200, maxLengthErrorMessage(200)),
  description: yup.string().required(requiredErrorMessage),
  date_start: yup.string().required(requiredErrorMessage),
  date_end: yup
    .string()
    .required(requiredErrorMessage)
    .test({
      name: 'moreThan',
      exclusive: true,
      message: 'Неверная дата',
      // eslint-disable-next-line
      test: function (value) {
        if (this.parent.date_start) {
          return moment(this.parent.date_start, 'YYYY-MM-DD').isSameOrBefore(moment(value, 'YYYY-MM-DD'));
        }
        return true;
      },
    }),
  date_award_start: yup.string().required(requiredErrorMessage),
  date_award_end: yup
    .string()
    .required(requiredErrorMessage)
    .test({
      name: 'moreThan',
      exclusive: true,
      message: 'Неверная дата',
      // eslint-disable-next-line
      test: function (value) {
        if (this.parent.date_award_start) {
          return moment(this.parent.date_award_start, 'YYYY-MM-DD').isSameOrBefore(moment(value, 'YYYY-MM-DD'));
        }
        return true;
      },
    }),
  kpi_name_ids: yup.array().of(yup.number()).min(1, requiredErrorMessage).required(requiredErrorMessage),
  brand_ids: yup.array().of(yup.number()).when('kpi_name_ids', {
    is: (kpi_name_ids: number[]) => kpi_name_ids && kpi_name_ids.length > 0,
    then: (schema) => schema.min(1, requiredErrorMessage).required(requiredErrorMessage),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export { validationSchema };
